import React from 'react'
import { Widget } from 'widgets-for-react'
import { any, fromJSX, Updater } from 'widgets-for-react'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, LocationPage, Page } from '../../cmsPageState'
import { LocationPageHeader } from './locationPageLayout'

export const locationPageWidget =
  (acceptVideoCookie: () => void) =>
  (page: LocationPage): Widget<Updater<Page>> =>
    any([
      fromJSX(() => (
        <LocationPageHeader
          title={page.title}
          intro={page.intro}
          image={page.image}
          link={page.link}
          phoneNumber={page.location?.phoneNumber}
          breadcrumbs={[
            { title: 'Spaarne Gasthuis', url: '/' },
            { title: 'Contact', url: '/contact' },
            { title: page.title, url: page.url },
          ]}
        />
      )),
      blocksWidget(acceptVideoCookie, {
        location: page.location
      })(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
    ])
